/**
 * Drop-in for `clsx` — join class names from strings, numbers,
 * arrays, and objects (truthy keys).
 */
export function clsx() {
  let out = ''
  for (let i = 0; i < arguments.length; i += 1) {
    const part = toVal(arguments[i])
    if (part) {
      out = out ? `${out} ${part}` : part
    }
  }
  return out
}

function toVal(mix) {
  if (mix == null || mix === false || mix === true || mix === '') return ''

  if (typeof mix === 'string' || typeof mix === 'number') {
    return String(mix)
  }

  if (Array.isArray(mix)) {
    let out = ''
    for (let i = 0; i < mix.length; i += 1) {
      const part = toVal(mix[i])
      if (part) out = out ? `${out} ${part}` : part
    }
    return out
  }

  if (typeof mix === 'object') {
    let out = ''
    for (const key in mix) {
      if (Object.prototype.hasOwnProperty.call(mix, key) && mix[key]) {
        out = out ? `${out} ${key}` : key
      }
    }
    return out
  }

  return ''
}

export default clsx
